import * as blog from './blog-routes';
import * as docs from './documentation-routes';
import * as faq from './faq-routes';
import { fundWizard } from './fund-wizard-route';
import { gift } from './gift-route';
import { makeRoute } from './makeRoute';
import * as marketing from './marketing-routes';
import * as miniApp from './mini-app-routes';
import * as overview from './overview-routes';
import * as partners from './partner-routes';

/**
 * The server-safe subset of `routes`.
 *
 * The main barrel re-exports wizardUtils, which imports nuqs's `createParser`
 * — client-only — so importing `@endaoment-frontend/routes` from a React
 * Server Component fails the build with "Attempted to call createParser() from
 * the server". app-routes has the same problem for the same reason.
 *
 * Everything here is a plain URL builder over config.baseUrls, so it renders on
 * the server. Reach for the main barrel from a client component when you need
 * the wizard-aware app routes.
 */
const app = {
  /** The app's front door. The wizard-aware routes live in the main barrel. */
  home: makeRoute(() => `/`, 'app'),
  /** The same plain path app-routes builds; here so a server page can link it. */
  universalImpactPool: makeRoute(() => `/universal`, 'app'),
  /**
   * The exceptions: the gift and fund wizards' doors are plain query strings,
   * so they need no parser and render on the server like everything else here.
   */
  gift,
  fundWizard,
};

export const routes = { app, blog, docs, faq, marketing, miniApp, overview, partners };

/** What a caller needs to name a method when building a gift link. */
export type { GiftLink, GiftMethod } from './gift-route';
